import { EntityTypes } from '../Types';
import { BaseEntity } from './BaseEntity';
import Chest from './Chest';
import Coin from './Coin';
import Token from './Token';
import Fireball from './Fireball';
import Boulder from './Boulder';
import SwordProj from './SwordProj';
import Ornament from './Ornament';
import Player from './Player';
import Snowball from './Snowball';
import Sword from './Sword';
import Bush from './mapObjects/Bush';
import House1 from './mapObjects/House1';
import IceMound from './mapObjects/IceMound';
import IcePond from './mapObjects/IcePond';
import IceSpike from './mapObjects/IceSpike';
import LavaPool from './mapObjects/LavaPool';
import LavaRock from './mapObjects/LavaRock';
import Ore from './mapObjects/Ore';
import MossyRock from './mapObjects/MossyRock';
import Pond from './mapObjects/Pond';
import Rock from './mapObjects/Rock';
import Cactus from './mapObjects/Cactus';
import OasisLake from './mapObjects/OasisLake';
import DeadBush from './mapObjects/DeadBush';
import AmbientShrub from './mapObjects/AmbientShrub';
import SandBlock from './SandBlock';
import SandBall from './SandBall';
import SphinxMob from './mobs/Sphinx';
import BunnyMob from './mobs/Bunny';
import ChimeraMob from './mobs/Chimera';
import MooseMob from './mobs/Moose';
import RokuMob from './mobs/Roku';
import AncientMob from './mobs/Ancient';
import WolfMob from './mobs/Wolf';
import CatMob from './mobs/Cat';
import YetiMob from './mobs/Yeti';
import SantaMob from './mobs/Santa';
import FishMob from './mobs/Fish';
import AngryFishMob from './mobs/AngryFish';
import IceSpiritMob from './mobs/IceSpirit';
import CaptureZone from './CaptureZone';
import ThrownSword from './ThrownSword';

export const EntityDepth: Record<any, number> = {
  [EntityTypes.CaptureZone]: 0.5,
  [EntityTypes.Pond]: 1,
  [EntityTypes.LavaPool]: 2,
  [EntityTypes.OasisLake]: 2,
  [EntityTypes.IcePond]: 3,
  [EntityTypes.IceSpike]: 4,
  [EntityTypes.Coin]: 5,
  [EntityTypes.Token]: 5.5,
  [EntityTypes.Chest]: 6,

  [EntityTypes.Rock]: 10,
  [EntityTypes.LavaRock]: 10,
  [EntityTypes.MossyRock]: 10,
  [EntityTypes.Ore]: 10,

  [EntityTypes.Wolf]: 11,
  [EntityTypes.Cat]: 11,
  [EntityTypes.Bunny]: 11,
  [EntityTypes.Moose]: 11,
  [EntityTypes.Fish]: 11,
  [EntityTypes.AngryFish]: 11,
  [EntityTypes.IceSpirit]: 11,

  [EntityTypes.Player]: 20,
  [EntityTypes.Sword]: 21,
  [EntityTypes.Fireball]: 22,
  [EntityTypes.Boulder]: 22,
  [EntityTypes.SwordProj]: 22,
  [EntityTypes.ThrownSword]: 22,
  [EntityTypes.Snowball]: 22,
  [EntityTypes.Ornament]: 22,
  [EntityTypes.Roku]: 23,
  [EntityTypes.Ancient]: 23,
  [EntityTypes.Yeti]: 23,
  [EntityTypes.Santa]: 23,

  [EntityTypes.Bush]: 30,
  [EntityTypes.IceMound]: 30,
  [EntityTypes.Cactus]: 30,
  [EntityTypes.DeadBush]: 30,

  [EntityTypes.AmbientShrub]: 4,
  [EntityTypes.SandBlock]: 22,
  [EntityTypes.SandBall]: 22,
  [EntityTypes.Sphinx]: 23,

  [EntityTypes.Chimera]: 31,
} as const;

export const GetEntityClass = (type: EntityTypes): typeof BaseEntity => {
  switch (type) {
    case EntityTypes.Player: return Player;
    case EntityTypes.Coin: return Coin;
    case EntityTypes.Token: return Token;
    case EntityTypes.House1: return House1;
    case EntityTypes.Chest: return Chest;
    case EntityTypes.Sword: return Sword;

    case EntityTypes.Wolf: return WolfMob;
    case EntityTypes.Cat: return CatMob;
    case EntityTypes.Bunny: return BunnyMob;
    case EntityTypes.Moose: return MooseMob;
    case EntityTypes.Fish: return FishMob;
    case EntityTypes.AngryFish: return AngryFishMob;
    case EntityTypes.IceSpirit: return IceSpiritMob;
    case EntityTypes.Chimera: return ChimeraMob;
    case EntityTypes.Yeti: return YetiMob;
    case EntityTypes.Santa: return SantaMob;
    case EntityTypes.Roku: return RokuMob;
    case EntityTypes.Ancient: return AncientMob;
    case EntityTypes.Fireball: return Fireball;
    case EntityTypes.Boulder: return Boulder;
    case EntityTypes.SwordProj: return SwordProj;
    case EntityTypes.Snowball: return Snowball;
    case EntityTypes.Ornament: return Ornament;

    case EntityTypes.Rock: return Rock;
    case EntityTypes.Bush: return Bush;
    case EntityTypes.Pond: return Pond;
    case EntityTypes.Cactus: return Cactus;
    case EntityTypes.OasisLake: return OasisLake;
    case EntityTypes.DeadBush: return DeadBush;
    case EntityTypes.AmbientShrub: return AmbientShrub;
    case EntityTypes.SandBlock: return SandBlock;
    case EntityTypes.SandBall: return SandBall;
    case EntityTypes.Sphinx: return SphinxMob;
    case EntityTypes.MossyRock: return MossyRock;
    case EntityTypes.IcePond: return IcePond;
    case EntityTypes.IceMound: return IceMound;
    case EntityTypes.IceSpike: return IceSpike;
    case EntityTypes.LavaRock: return LavaRock;
    case EntityTypes.Ore: return Ore;
    case EntityTypes.LavaPool: return LavaPool;
    case EntityTypes.ThrownSword: return ThrownSword;
    case EntityTypes.CaptureZone: return CaptureZone;

    default:
      console.trace('Unknown entity type: ', type);
      return BaseEntity;
  }
}
